import { Box, Stack, TableBody, TableCell, TableRow } from '@mui/material';
import axios from 'axios';
import { useEffect, useState } from 'react';

import {
  FlexBox,
  PersitedDatePicker,
  TableCustom,
} from '../../../components/common';
import { AddButton } from '../../../components/common/button/CustomButtons';
import ModalCustom from '../../../components/common/Modal';
import ChildHeader from '../../../components/ui/ChildHeader';
import { useQuery } from '../../../hooks/UseQuery';
import { useAuth } from '../../../services/auth/AuthProvider';
import DatePickerMui from '../../../components/common/DatePickerMui';
import moment from 'moment';
import {
  DeleteIconButton,
  EditIconButton,
  ViewIconButton,
} from '../../../components/common/button/CustomIconButton';
import { useNavigate } from 'react-router-dom';
import { getListMonthly } from '../helpers/utils';
import { getColumnLength } from '../helpers/utils';
import AutocompleteMuiCustom from '../../../components/common/AutocompleteMuiCustom';
import AlertMui from '../../../components/common/AlertMui';
const Header = [
  [
    {
      text: '#',
      colspan: 1,
      rowspan: 1,
    },

    {
      text: 'Month & Year',
      colspan: 1,
      rowspan: 1,
    },
    {
      text: 'ACTION',
      colspan: 1,
      rowspan: 1,
    },
  ],
];

const List = () => {
  const { state } = useAuth();
  const date = useQuery('date');
  const [tableData, setTableData] = useState<any[]>([]);
  const [render, setRender] = useState(false);
  const { user } = state;
  const navigate = useNavigate();
  const [alert, setAlert] = useState(false);

  useEffect(() => {
    let data = getListMonthly(date);
    setTableData(data);
  }, [date]);

  return (
    <Box>
      <ChildHeader text="Monthly Sales Plan"></ChildHeader>
      <Box
        sx={{
          margin: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <PersitedDatePicker label="Search By Month" views={['year']} />
      </Box>
      <TableCustom tableHeaderObj={Header}>
        <TableBody>
          {tableData.map(
            (document: { [key: string]: any }, documentIndex: number) => (
              <TableRow>
                <TableCell align="center">{documentIndex + 1}</TableCell>
                <TableCell align="center">{document?.month_year}</TableCell>

                <TableCell>
                  <Stack direction="row" sx={{ justifyContent: 'center' }}>
                    <EditIconButton
                      tooltipTitle="EDIT"
                      onClick={() => {
                        navigate(
                          `/admin/createMonthlySalesPlan?annual_date=${document?.month_year}&created_date=${document?.created_date}&isView=false`
                        );
                      }}
                    />
                    <ViewIconButton
                      tooltipTitle="view"
                      onClick={() => {
                        navigate(
                          `/admin/createMonthlySalesPlan?annual_date=${document?.month_year}&created_date=${document?.created_date}&isView=true`
                        );
                      }}
                    />
                  </Stack>
                </TableCell>
              </TableRow>
            )
          )}
        </TableBody>
      </TableCustom>
      <AlertMui
        alert={alert}
        message={'please select an Customer First!'}
        setAlert={setAlert}
        severity={'warning'}
      />
    </Box>
  );
};

export default List;
